import { Box, SpaceBetween, TextFilter, Toggle } from '@amzn/awsui-components-console';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import FormattedLogs from './FormattedLogs';

export default function LogsNavigator(props: { logs: string[]; loading?: boolean }) {
	const [filteringText, setFilteringText] = useState('');
	//Whether to display a formatted version of the logs, or to display their raw text
	const [rawToggle, setRawToggle] = useState(false);
	// Whether to hide the directory and line information of the logged file
	// e.g. "/apollo/env/awsdwetl-workerservice/ruby2.3.x/lib/ruby/gems/2.3.0/gems/aws-sdk-core-3.130.0/lib/seahorse/client/net_http/handler.rb at line 38:"
	const [pathToggle, setPathToggle] = useState(false);
	// Whether to hide the timestamp for log lines that have them
	const [timestampToggle, setTimestampToggle] = useState(false);

	return (
		<SpaceBetween direction="vertical" size="m">
			<TextFilter
				filteringText={filteringText}
				filteringPlaceholder="Filter logs with terms separated by spaces"
				filteringAriaLabel="Filter logs"
				onChange={({ detail }) => setFilteringText(detail.filteringText)}
			/>
			<SpaceBetween direction="horizontal" size="m">
				<Box float="right">
					<Toggle checked={rawToggle} onChange={({ detail }) => setRawToggle(detail.checked)}>
						Display raw logs
					</Toggle>
				</Box>
				<Box float="right">
					<Toggle
						checked={pathToggle}
						onChange={({ detail }) => setPathToggle(detail.checked)}
						disabled={rawToggle}
					>
						Display path
					</Toggle>
				</Box>
				<Box float="right">
					<Toggle
						checked={timestampToggle}
						onChange={({ detail }) => setTimestampToggle(detail.checked)}
						disabled={rawToggle}
					>
						Display timestamp
					</Toggle>
				</Box>
			</SpaceBetween>
			{props.loading ? (
				<LogsLoadingSkeleton />
			) : (
				<FormattedLogs
					logsList={props.logs}
					filterText={filteringText}
					rawToggle={rawToggle}
					pathToggle={pathToggle}
					timestampToggle={timestampToggle}
				/>
			)}
		</SpaceBetween>
	);
}

// Loading bars while fetching logs
function LogsLoadingSkeleton() {
	return (
		<SpaceBetween size="l">
			{React.Children.toArray(
				Array(5).fill(
					<Box>
						<Skeleton height="1.1em" />
						<Skeleton height="1.1em" />
						<Skeleton height="1.1em" />
					</Box>
				)
			)}
		</SpaceBetween>
	);
}
